export const removeSubstringWithParenthesis = (input: string) => {
    return input.replace(/\(.*?\)/g, "").trim();
};
